import $ from "jquery";
import AOS from "aos";
import "slick-carousel";
import "./modules/header";
import "./modules/menu";
import "./modules/open-modal";

$(document).ready(() => {
  AOS.init({ once: false, duration: 600 });
});

